export const testClubInvitation = {
  label: 'Try ShuttleOps free with a test club',
  description: 'Seven days. 10 fake players. No card or setup call.',
  href: '/test-club',
};

export const testClubPlacements = {
  '/compare/clubmon-alternative': 'clubmon-hero',
  '/compare/sporteasy-alternative': 'sporteasy-hero',
  '/your-club': 'outreach-hero',
  '/sports-club-app': 'sports-app-hero',
  '/guides/switch-from-playwaze': 'switch-playwaze-bottom',
  '/guides/switch-from-spond': 'switch-spond-bottom',
  '/compare/justgo-alternative': 'justgo-bottom',
  '/compare/sportmember-alternative': 'sportmember-bottom',
  '/guides/switch-from-justgo-to-shuttleops': 'switch-justgo-bottom',
  '/guides/badminton-pegboard': 'pegboard-guide-bottom',
  '/features/managers': 'managers-bottom',
};
